import { MEDIA_ASSETS } from './mediaAssets';

export type ExperienceCategory = 'SUP' | 'BIKE' | 'SKI';

export type ExperienceTheme = {
  key: ExperienceCategory;
  label: string;
  accent: string;
  accentSoft: string;
  headerGradient: string;
  heroImage: string;
  heroVideo?: string;
  heroTitle: string;
  heroSubtitle: string;
  activities: string[];
  routes: string[];
  galleryHeadline: string;
  shopHeadline: string;
};

export const EXPERIENCE_CATEGORY_LABELS: Record<ExperienceCategory, string> = {
  SUP: 'WATER ADVENTURES',
  BIKE: 'OUTDOOR LIFE',
  SKI: 'SUMMIT DIVISION'
};

export const EXPERIENCE_THEMES: Record<ExperienceCategory, ExperienceTheme> = {
  SUP: {
    key: 'SUP',
    label: EXPERIENCE_CATEGORY_LABELS.SUP,
    accent: '#1183d4',
    accentSoft: '#d7ecfb',
    headerGradient: 'linear-gradient(90deg, #0f2230 0%, #0c1b27 100%)',
    heroImage: MEDIA_ASSETS.supHero,
    heroVideo: MEDIA_ASSETS.supHeroVideo,
    heroTitle: "Experience the Thrill of Antalya's Waters",
    heroSubtitle:
      'Premium water sports experiences for groups, private sessions, and coastal explorers. From calm paddling routes to dynamic water adventures, discover Antalya’s waters your way. We recommend reviewing our routes in the “ROUTES” section before booking.',
    activities: ['Stand Up Paddle (SUP)', 'SUP Yoga', 'Sunrise Paddle', 'Group SUP Session'],
    routes: ['Antalya Cliffs', 'Blue Caves Tour', 'Suluada Island', 'River Expedition'],
    galleryHeadline: 'SUP moments from groups, sunrise sessions and coast routes.',
    shopHeadline: 'SUP gear catalog for rental and sales inquiries.'
  },
  BIKE: {
    key: 'BIKE',
    label: EXPERIENCE_CATEGORY_LABELS.BIKE,
    accent: '#d97706',
    accentSoft: '#fff0d9',
    headerGradient: 'linear-gradient(90deg, #2c1c06 0%, #1f1404 100%)',
    heroImage: MEDIA_ASSETS.bikeHero,
    heroTitle: 'Ride Antalya with Guided Bike Programs',
    heroSubtitle:
      'Curated outdoor experiences for exploration, movement, and connection with nature. Cycling, hiking, camping, and discovery routes designed to enjoy the outdoors your way.',
    activities: ['City Bike Tour', 'Forest MTB Session', 'Road Bike Group Ride', 'Sunset Bike Route'],
    routes: ['Old Town Loop', 'Lara Coastal Ride', 'Forest Trail', 'Mountain View Route'],
    galleryHeadline: 'Bike tours, city rides and forest route highlights.',
    shopHeadline: 'Bike equipment and accessories for guided tours.'
  },
  SKI: {
    key: 'SKI',
    label: EXPERIENCE_CATEGORY_LABELS.SKI,
    accent: '#0ea5a4',
    accentSoft: '#daf6f4',
    headerGradient: 'linear-gradient(90deg, #052628 0%, #041d1f 100%)',
    heroImage:
      'https://images.unsplash.com/photo-1488441770602-aed21fc49bd5?q=80&w=1974&auto=format&fit=crop',
    heroTitle: 'High Altitude Climbing and Winter Skiing Sports Planning',
    heroSubtitle:
      'High-altitude adventures built on discipline, endurance, and respect for the mountains. Rock and mountain climbing, skiing, and snowboarding experiences designed to challenge both body and mind.',
    activities: ['Beginner Ski Session', 'Family Ski Day', 'Advanced Slope Program', 'Snowboard Starter'],
    routes: ['Saklikent Easy Line', 'Summit Mid Route', 'Alpine Advanced Zone', 'Private Ski Track'],
    galleryHeadline: 'Ski days, slope coaching and winter team events.',
    shopHeadline: 'Ski and winter gear catalog for seasonal planning.'
  }
};

export const EXPERIENCE_ORDER: ExperienceCategory[] = ['SUP', 'BIKE', 'SKI'];
